export function ActiveIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.21246 4.08121C9.07863 4.21504 8.94479 4.34888 8.80959 4.48408C8.48729 4.80638 8.16636 5.12731 7.84406 5.44961C7.45621 5.83746 7.06972 6.22395 6.68187 6.6118C6.34592 6.94776 6.00996 7.28371 5.67537 7.6183C5.51422 7.77945 5.3558 7.94606 5.19056 8.10312C5.18373 8.10994 5.1769 8.11541 5.17007 8.12223C5.20694 8.09356 5.24382 8.06488 5.28069 8.0362C5.26976 8.04439 5.25884 8.04985 5.24791 8.05532C5.29162 8.03756 5.33532 8.01844 5.37902 8.00069C5.36673 8.00479 5.3558 8.00888 5.34215 8.01025C5.38994 8.00342 5.43911 7.99659 5.48691 7.99113C5.47462 7.9925 5.46232 7.9925 5.45003 7.99113C5.49783 7.99796 5.547 8.00479 5.59479 8.01025C5.5825 8.00888 5.57021 8.00615 5.55792 8.00069C5.60162 8.01844 5.64533 8.03756 5.68903 8.05532C5.67674 8.04985 5.66581 8.04439 5.65625 8.0362C5.69312 8.06488 5.73 8.09356 5.76687 8.12223C5.69449 8.05941 5.62894 7.98567 5.56065 7.91875C5.4036 7.7617 5.24791 7.60601 5.09086 7.44896C4.73715 7.09525 4.38481 6.7429 4.0311 6.3892C3.94916 6.30725 3.86858 6.22668 3.78664 6.14474C3.58452 5.94262 3.21306 5.9276 3.01367 6.14474C2.81292 6.36325 2.7979 6.70193 3.01367 6.91771C3.44522 7.34926 3.87678 7.78082 4.3097 8.21373C4.51728 8.42132 4.72623 8.63027 4.93381 8.83785C4.94883 8.85287 4.96249 8.86789 4.97751 8.88155C5.25338 9.14649 5.68083 9.14649 5.95806 8.88292C5.97991 8.86243 6.00177 8.83921 6.02225 8.81873C6.4183 8.42268 6.81571 8.02527 7.21175 7.62923C7.7908 7.05018 8.36848 6.4725 8.94752 5.89346C9.28894 5.55204 9.63309 5.21472 9.97041 4.87057C9.97588 4.8651 9.98134 4.85964 9.9868 4.85418C10.1889 4.65206 10.2039 4.2806 9.9868 4.08121C9.76693 3.88045 9.42824 3.86543 9.21246 4.08121Z"
        fill="white"
      />
      <path
        d="M11.9081 6.50251C11.9081 6.76882 11.8904 7.03513 11.8549 7.30007C11.8617 7.25227 11.8685 7.2031 11.874 7.15531C11.8043 7.67426 11.6664 8.18093 11.4643 8.66301C11.482 8.61931 11.5011 8.57561 11.5189 8.53191C11.3181 9.00852 11.0559 9.45647 10.7405 9.86617C10.7691 9.8293 10.7978 9.79242 10.8265 9.75555C10.5151 10.1571 10.1546 10.5176 9.75309 10.829C9.78996 10.8003 9.82683 10.7716 9.86371 10.7429C9.454 11.0584 9.00606 11.3206 8.52944 11.5214C8.57314 11.5036 8.61685 11.4845 8.66055 11.4667C8.17847 11.6689 7.67043 11.8068 7.15284 11.8764C7.20064 11.8696 7.24981 11.8628 7.29761 11.8573C6.76909 11.927 6.23238 11.927 5.70387 11.8573C5.75166 11.8641 5.80083 11.871 5.84863 11.8764C5.32967 11.8068 4.82301 11.6689 4.34092 11.4667C4.38462 11.4845 4.42833 11.5036 4.47203 11.5214C3.99541 11.3206 3.54747 11.0584 3.13776 10.7429C3.17464 10.7716 3.21151 10.8003 3.24838 10.829C2.84688 10.5176 2.48634 10.1571 2.17496 9.75555C2.20364 9.79242 2.23232 9.8293 2.261 9.86617C1.94553 9.45647 1.68332 9.00852 1.48257 8.53191C1.50032 8.57561 1.51944 8.61931 1.53719 8.66301C1.33508 8.18093 1.19714 7.6729 1.12749 7.15531C1.13432 7.2031 1.14115 7.25227 1.14661 7.30007C1.07696 6.77155 1.07696 6.23484 1.14661 5.70633C1.13978 5.75413 1.13296 5.80329 1.12749 5.85109C1.19714 5.33213 1.33508 4.82547 1.53719 4.34339C1.51944 4.38709 1.50032 4.43079 1.48257 4.47449C1.68332 3.99787 1.94553 3.54993 2.261 3.14023C2.23232 3.1771 2.20364 3.21397 2.17496 3.25085C2.48634 2.84934 2.84688 2.4888 3.24838 2.17743C3.21151 2.20611 3.17464 2.23479 3.13776 2.26346C3.54747 1.94799 3.99541 1.68578 4.47203 1.48503C4.42833 1.50278 4.38462 1.5219 4.34092 1.53966C4.82301 1.33754 5.33104 1.1996 5.84863 1.12996C5.80083 1.13678 5.75166 1.14361 5.70387 1.14907C6.23238 1.07943 6.76909 1.07943 7.29761 1.14907C7.24981 1.14225 7.20064 1.13542 7.15284 1.12996C7.6718 1.1996 8.17847 1.33754 8.66055 1.53966C8.61685 1.5219 8.57314 1.50278 8.52944 1.48503C9.00606 1.68578 9.454 1.94799 9.86371 2.26346C9.82683 2.23479 9.78996 2.20611 9.75309 2.17743C10.1546 2.4888 10.5151 2.84934 10.8265 3.25085C10.7978 3.21397 10.7691 3.1771 10.7405 3.14023C11.0559 3.54993 11.3181 3.99787 11.5189 4.47449C11.5011 4.43079 11.482 4.38709 11.4643 4.34339C11.6664 4.82547 11.8043 5.3335 11.874 5.85109C11.8671 5.80329 11.8603 5.75413 11.8549 5.70633C11.8904 5.9699 11.9081 6.23621 11.9081 6.50251C11.9081 6.78794 12.1594 7.06244 12.4544 7.04878C12.7494 7.03513 13.0007 6.80843 13.0007 6.50251C12.9993 5.83197 12.8982 5.15186 12.6907 4.51409C12.4899 3.89681 12.2004 3.30411 11.8234 2.77423C11.6254 2.49563 11.4096 2.22796 11.172 1.98214C10.9344 1.73495 10.6736 1.51508 10.4018 1.30613C9.88556 0.910082 9.30788 0.606902 8.69742 0.382932C8.07058 0.152133 7.39867 0.0305882 6.73222 0.00464041C6.06167 -0.0213074 5.37747 0.0619987 4.73151 0.243633C4.10739 0.419805 3.49967 0.69294 2.9575 1.05075C2.42079 1.40446 1.92778 1.83191 1.51944 2.32765C1.30093 2.59123 1.09881 2.86846 0.921276 3.16344C0.742373 3.46116 0.596246 3.77253 0.465141 4.0921C0.211126 4.70939 0.0704614 5.36764 0.0185658 6.03136C-0.0346955 6.70737 0.0281255 7.39703 0.187909 8.05529C0.340865 8.68759 0.597611 9.30488 0.934933 9.86071C1.26816 10.4083 1.68469 10.9164 2.16404 11.3425C2.64749 11.7713 3.18829 12.1359 3.77827 12.4022C4.09647 12.5456 4.4215 12.6713 4.75745 12.7641C5.1016 12.8597 5.45122 12.9198 5.80629 12.9608C6.48093 13.0386 7.16514 12.9977 7.83022 12.8638C8.47072 12.7341 9.0962 12.4965 9.66705 12.1796C10.227 11.8682 10.7473 11.4654 11.1911 11.001C11.635 10.5367 12.0187 10.0027 12.3055 9.42642C12.5992 8.83645 12.8136 8.20551 12.9133 7.55408C12.9665 7.20447 13.0007 6.85349 13.002 6.49978C13.002 6.21436 12.7507 5.93986 12.4558 5.95351C12.158 5.9699 11.9081 6.1966 11.9081 6.50251Z"
        fill="white"
      />
    </svg>
  );
}

export function SeekIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1978_7193"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        x="1"
        y="1"
        width="14"
        height="14"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.33325 1.83333H14.3178V14.818H1.33325V1.83333Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1978_7193)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.82568 2.83333C4.79701 2.83333 2.33301 5.29666 2.33301 8.32533C2.33301 11.354 4.79701 13.818 7.82568 13.818C10.8537 13.818 13.3177 11.354 13.3177 8.32533C13.3177 5.29666 10.8537 2.83333 7.82568 2.83333ZM7.82568 14.818C4.24567 14.818 1.33301 11.9053 1.33301 8.32533C1.33301 4.74533 4.24567 1.83333 7.82568 1.83333C11.4057 1.83333 14.3177 4.74533 14.3177 8.32533C14.3177 11.9053 11.4057 14.818 7.82568 14.818Z"
          fill="white"
        />
      </g>
      <mask
        id="mask1_1978_7193"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="12"
        width="4"
        height="4"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.4932 12.3046H14.8425V15.6478H11.4932V12.3046Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1978_7193)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.3427 15.6478C14.2153 15.6478 14.0873 15.5991 13.9893 15.5018L11.64 13.1591C11.4447 12.9638 11.444 12.6471 11.6393 12.4518C11.834 12.2551 12.1507 12.2565 12.3467 12.4505L14.696 14.7938C14.8913 14.9891 14.892 15.3051 14.6967 15.5005C14.5993 15.5991 14.4707 15.6478 14.3427 15.6478Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export function ExpiredIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33325 10.5H8.66659V11.8333H7.33325V10.5ZM7.33325 5.16668H8.66659V9.16668H7.33325V5.16668ZM7.99325 1.83334C4.31325 1.83334 1.33325 4.82001 1.33325 8.50001C1.33325 12.18 4.31325 15.1667 7.99325 15.1667C11.6799 15.1667 14.6666 12.18 14.6666 8.50001C14.6666 4.82001 11.6799 1.83334 7.99325 1.83334ZM7.99992 13.8333C5.05325 13.8333 2.66659 11.4467 2.66659 8.50001C2.66659 5.55334 5.05325 3.16668 7.99992 3.16668C10.9466 3.16668 13.3333 5.55334 13.3333 8.50001C13.3333 11.4467 10.9466 13.8333 7.99992 13.8333Z"
        fill="white"
      />
    </svg>
  );
}

export function ExpiringIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99325 1.83334C4.31325 1.83334 1.33325 4.82001 1.33325 8.50001C1.33325 12.18 4.31325 15.1667 7.99325 15.1667C11.6799 15.1667 14.6666 12.18 14.6666 8.50001C14.6666 4.82001 11.6799 1.83334 7.99325 1.83334ZM7.99992 13.8333C5.05325 13.8333 2.66659 11.4467 2.66659 8.50001C2.66659 5.55334 5.05325 3.16668 7.99992 3.16668C10.9466 3.16668 13.3333 5.55334 13.3333 8.50001C13.3333 11.4467 10.9466 13.8333 7.99992 13.8333ZM8.33325 5.16668H7.33325V9.16668L10.8333 11.2667L11.3333 10.4467L8.33325 8.66668V5.16668Z"
        fill="white"
      />
    </svg>
  );
}
